module.exports = __webpack_public_path__ + "img/analyse.69bf1263.png";